import './search.styles';

import { throttle } from 'throttle-debounce';

import initPage from '@/scripts/init/init';
import initBlogLayout from '@/layouts/blog/blog-layout';
import Pagination from '@/components/Pagination/Pagination';

import SearchList from './scripts/SearchList';
import Search from './scripts/Search';
import SearchForm from './scripts/SearchForm';

const $page = document.querySelector('.search-js');
const $searchForm = $page.querySelector('.search-from-js');
const $searchList = $page.querySelector('.search-list-js');
const $pagination = $page.querySelector('.pagination-js');

const { query, page, pageSize } = getParams();

const search = window.s = new Search($page, {
   searchForm: new SearchForm($searchForm, { query }),
   searchList: new SearchList($searchList, {
      pagination: new Pagination($pagination),
      scrollTo: document.body,
      initialPage: page,
      pageSize,
   }),
});

initPage();
initBlogLayout();
initEvents();
start();

function start() {
   search.searchForm.focus();
}

function initEvents() {
   search.searchList.events.addListener('update.before', () => {
      updateQuery();
      updateTitle();
   });

   search.searchForm.events.addListener('change', () => {
      updateQuery();
      updateTitle();
   });

   window.addEventListener('popstate', throttle(50, () => {
      readParams();
   }));
}

function updateQuery() {
   const { query, page } = search.searchList;
   const url = new URL(location.href);
   const q = url.searchParams;

   q.delete('query');
   q.delete('page');

   if (query) q.set('query', query);
   if (page) q.set('page', page + 1);

   if (url.toString() === location.href) return;
   history.pushState(null, null, url);
}

function readParams() {
   const { query, page } = getParams();
   search.restart(query, page);
}

function getParams() {
   const s = new URL(location).searchParams;
   const query = (s.get('query') || '').trim();
   let page = s.get('page');
   let pageSize = s.get('pagesize');

   page = (page && isFinite(page)) ? Math.max(page - 1, 0) : 0;
   pageSize = (pageSize && isFinite(pageSize)) ? Math.max(pageSize, 1) : 10;

   return { query, page, pageSize };
}

function updateTitle() {
   // let title = ``;
   // setTitle(title);
}